<div class="p-10 h-full">
    <nz-page-header class="text-[16px] font-semibold p-0 m-0" nzTitle="Órdenes de producción">
        <nz-page-header-extra class="flex items-center justify-items-end">
            @if(multipleMachines) {
                <nz-select
                    nzShowSearch
                    nzPlaceHolder="Filtrar por máquina"
                    [(ngModel)]="filterMachineId"
                    (ngModelChange)="onMachineFilterChange($event)"
                    class="ml-2 min-w-[180px] max-w-[300px] mr-4"
                    nzAllowClear
                >
                    @for(machine of selectableMachines; track machine.id) {
                        <nz-option [nzLabel]="machine.name" [nzValue]="machine.id"></nz-option>
                    }
                </nz-select>
            }
            <!------------------------------------------------>
            <!------------------- FILTER INPUT --------------->
            <div class="flex">
                <nz-input-group [nzPrefix]="searchIcon" [nzSuffix]="inputClearTpl"
                    class="rounded-lg border border-gray-300">
                    <input onfocus="select()"
                        class="block px-4 text-[15px] font-medium py-1 pl-10 w-[275px] text-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Nº orden / Cliente / Referencia / Ref.Art. / Lote" nz-input [(ngModel)]="filterText"
                        (ngModelChange)="saveLastTextFilter()" (keyup.enter)="getPaginatedOrders()" />
                </nz-input-group>
                <ng-template #inputClearTpl>
                    @if (filterText) {
                    <span class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle" (click)="clearFilter()"
                        nz-icon></span>
                    }
                </ng-template>
                <ng-template #searchIcon>
                    <span nz-icon nzType="search"></span>
                </ng-template>
            </div>

            @if (canCreate() || showWithProductionOrdersPermissions('urgentBtn')) {
            <div class="flex">
                @if(innerWidth > WIDTH_VIEW_LIST_COMPONENT_ACTIONS){

                @if (this.orderSelected && showWithProductionOrdersPermissions('urgentBtn')) {
                @if (showWithProductionOrdersPermissions('urgentBtn')) {
                <button (click)="setSelectedOrderAsUrgent()" class="ml-1 button secondary-button">
                    Marcar como urgente
                </button>
                }

                <button (click)="setOrderSelected($event, null)" type="button"
                    class="text-blue-700 border border-blue-700 hover:bg-blue-700 hover:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm p-2 ml-1 text-center inline-flex items-center dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:focus:ring-blue-800">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12">
                        </path>
                    </svg> </button>
                }

                }@else {
                @if (this.orderSelected && showWithProductionOrdersPermissions('urgentBtn')) {
                <button nz-dropdown [nzDropdownMenu]="moreActionsMenu" class="ml-1 button neutral-outlined-button">
                    <span nz-icon nzType="down"></span>
                </button>
                <nz-dropdown-menu #moreActionsMenu="nzDropdownMenu">
                    <ul nz-menu>
                        @if (showWithProductionOrdersPermissions('urgentBtn')) {
                        <li nz-menu-item (click)="setSelectedOrderAsUrgent()">
                            <a>Marcar como urgente</a>
                        </li>
                        }
                        <li nz-menu-item (click)="setOrderSelected($event, null)">
                            <a>Deseleccionar orden</a>
                        </li>
                    </ul>
                </nz-dropdown-menu>
                }
                }

                @if (canCreate()) {
                <button class="ml-1 button primary-button" (click)="openCreateOrderDrawer()">
                    @if(innerWidth > WIDTH_VIEW_LIST_COMPONENT_ACTIONS){
                    Nuevo
                    }@else {
                    <span nz-icon nzType="plus"></span>
                    }
                </button>
                }
            </div>
            }
        </nz-page-header-extra>
    </nz-page-header>

    <div #tableContainer class="mt-[15px] h-[calc(100%_-_100px)] max-h-[calc(100%_-_100px)]">
        <nz-table #nestedTable nzTableLayout="fixed" [nzSize]="loggedScreen ? 'default' : 'small'"
            [nzData]="productionOrdersFiltered" [nzLoading]="isLoading" [nzLoadingIndicator]="indicatorTemplate"
            [nzTotal]="totalOrders" [nzBordered]="true" [nzFrontPagination]="false"
            [nzScroll]="{ y: (tableHeight || 0) + 'px', x:'240px' }" nzShowSizeChanger [nzPageSize]="pageSize"
            [nzPageIndex]="pageIndex" (nzQueryParams)="onQueryParamsChange($event)">
            <thead>
                <tr>
                    @if (showWithProductionOrdersPermissions('expandableRow')) {
                    <th nzWidth="30px"></th>
                    }
                    <th nzWidth="100px">Núm</th>
                    <th nzWidth="150px" nzColumnKey="priorityOrder" [nzSortFn]="true" [nzSortOrder]="'ascend'"
                        [nzSortDirections]="['ascend', 'descend', null]">
                        Orden de prioridad
                    </th>
                    @if (showWithProductionOrdersPermissions('priorityNameColumn')) {
                        <th nzWidth="100px" nzColumnKey="priority" [nzSortFn]="true" [nzSortOrder]="null"
                            [nzSortDirections]="['ascend', 'descend', null]">
                            Prioridad
                        </th>
                    }
                    <th nzWidth="300px">Descripción</th>
                    <th nzWidth="120px">Fecha creación</th>
                    <th nzWidth="150px">Cliente</th>
                    @if (showWithProductionOrdersPermissions('productionRouteColumn')) {
                        <th nzWidth="150px">Ruta</th>
                    }
                    <th nzWidth="120px" nzColumnKey="filterStatus" [nzFilters]="filterStatus" [nzFilterFn]="true"
                        [nzFilterMultiple]="true">Estado</th>
                    @if (canMainSubKey('productionOrderDetail')) {
                    <th nzWidth="100px">Progreso</th>
                    }
                    @if(canMainSubKey('productionOrderDetail') || canMainSubKey('productionOrderProcessDetail') ||
                    canRead() || canEdit() || canDelete()){
                    <th nzRight nzWidth="200px">Acciones</th>
                    }
                </tr>
            </thead>
            <tbody>
                @for (data of nestedTable.data; track data.id) {
                <tr class="hover:cursor-pointer text-[13px] min-h-[48px] h-[48px] {{
                            orderSelected !== null &&
                            orderSelected !== undefined &&
                            orderSelected.id === data.id
                                ? 'bg-gray-200 hover:bg-gray-200'
                                : ''
                        }}" (click)="
                                showWithProductionOrdersPermissions('urgentBtn') && data.status?.id !== ProductionOrderStateIdsEnum.FINISHED
                                ? setOrderSelected($event, data)
                                : setOrderSelected($event, null)
                        ">
                    @if (showWithProductionOrdersPermissions('expandableRow')) {
                    <td [(nzExpand)]="data.expand" class="text-center align-middle"></td>
                    }

                    <td class="text-right align-middle">
                        @if (idColumnValueToShow == 'id') {
                            {{ data.id }}
                        }
                        @else if (idColumnValueToShow == 'externalId') {
                            {{ data.externalId }}
                        }
                        @else if (idColumnValueToShow == 'finalProduct') {
                            {{ getIdColumnValue(data) }}
                        }
                        @else {
                            -
                        }
                    </td>

                    <td>
                        <div class="flex items-center justify-center">
                            <span>
                                {{ data.priorityOrder }}
                            </span>
                        </div>
                    </td>

                    @if (showWithProductionOrdersPermissions('priorityNameColumn')) {
                        <td>
                            <div class="flex items-center justify-center">
                                <span [class]="data.priority?.cssClassName">
                                    {{ data.priority?.name }}
                                </span>
                            </div>
                        </td>
                    }

                    <td nzEllipsis [nzTooltipTitle]="data.description" nzTooltipPlacement="bottom" nz-tooltip>
                        {{ data.description }}
                    </td>
                    <td class="text-center">
                        @if (showWithProductionOrdersPermissions('confirmationDateColumn')) {
                        {{
                        data.confirmationDate | date: "dd/MM/YYYY"
                        }}
                        } @else {
                        {{
                        data.createdAt | date: "dd/MM/YYYY"
                        }}
                        }
                    </td>

                    <td nzEllipsis [nzTooltipTitle]="data.customers?.name || '-'" nzTooltipPlacement="bottom" nz-tooltip
                        class="text-sky-500 font-medium"
                        (click)="data.customers ? customerFilter(data.customers!.name):''">
                        {{ data.customers?.name || "-" }}
                    </td>

                    @if (showWithProductionOrdersPermissions('productionRouteColumn')) {
                        <td nzEllipsis [nzTooltipTitle]="data.productionRoute?.name || '-'" nzTooltipPlacement="bottom"
                            nz-tooltip>
                            {{ data.productionRoute?.name || "-" }}
                        </td>
                    }

                    <td class="text-center align-middle">
                        <span [ngClass]="data.status?.cssClassName">
                            {{ data.status?.name }}
                        </span>
                    </td>

                    <!-- % REALIZADO DE ORDEN -->
                    @if (canMainSubKey('productionOrderDetail')) {
                    <td style="width: 140px !important;text-overflow: ellipsis;">
                        <nz-progress [nzPercent]="calculateStepper(data)" nzSize="small"></nz-progress>
                    </td>
                    }

                    @if(canMainSubKey('productionOrderDetail') || canMainSubKey('productionOrderProcessDetail') ||
                    canRead() || canEdit() || canDelete()){
                    <td nzRight>
                        <div class="flex align-middle justify-center">
                            @if(canMainSubKey('productionOrderDetail') ||
                            canMainSubKey('productionOrderProcessDetail')){
                            <button nz-button nzType="text" nzShape="circle" class="table-icon"
                                [nzTooltipTitle]="canMainSubKey('productionOrderDetail') ? 'Ver orden' : (canMainSubKey('productionOrderProcessDetail') ? 'Ver proceso' : '')"
                                nzTooltipPlacement="bottom" nz-tooltip
                                (click)="canMainSubKey('productionOrderDetail') ? navigateToOrder(data.id) : (canMainSubKey('productionOrderProcessDetail') ? navigateToProcess(data.id) : '')">
                                <span nz-icon
                                    [nzType]="canMainSubKey('productionOrderDetail') ? 'fund-view' : (canMainSubKey('productionOrderProcessDetail') ? 'eye' : '')"></span>
                            </button>
                            @if (canRead() || canEdit() || canDelete()) {
                            <nz-divider nzType="vertical"></nz-divider>
                            }
                            }

                            @if (canRead()) {
                            <button nz-button nzType="text" nzShape="circle" class="table-icon"
                                [nzTooltipTitle]="'Ver formulario orden'" nzTooltipPlacement="bottom" nz-tooltip
                                (click)="viewOrder(data.id)">
                                <span nz-icon nzType="eye"></span>
                            </button>
                            @if (canEdit() || canDelete()) {
                            <nz-divider nzType="vertical"></nz-divider>
                            }
                            }

                            @if (canEdit()) {
                            <button nz-button nzType="text" nzShape="circle" class="table-icon"
                                [nzTooltipTitle]="'Editar orden'" nzTooltipPlacement="bottom" nz-tooltip
                                (click)="editOrder(data.id)">
                                <span nz-icon nzType="edit"></span>
                            </button>
                            @if (canDelete()) {
                            <nz-divider nzType="vertical"></nz-divider>
                            }
                            }

                            @if (canDelete()) {
                            <button nz-button nzType="text" nzShape="circle" class="table-icon"
                                [nzTooltipTitle]="'Eliminar orden'" nzTooltipPlacement="bottom" nz-tooltip
                                (click)="deleteOrder(data.id)">
                                <span nz-icon nzType="delete"></span>
                            </button>
                            }
                        </div>
                    </td>
                    }
                </tr>

                <!------------------------------------------------------------------->
                <!--------------------------- EXPANDIDA ----------------------------->
                <!------------------------------------------------------------------->
                <tr [nzExpand]="data.expand?data.expand:false">
                    <nz-table #innerTable [nzData]="data.productionOrderProcesses?data.productionOrderProcesses:[]"
                        [nzFrontPagination]="false" [nzShowPagination]="false" [nzBordered]="true" nzTableLayout="auto"
                        nzSize="small">
                        <thead>
                            <tr>
                                <th nzWidth="100px">Orden Fab.</th>
                                <th>Proceso</th>
                                <th nzWidth="120px">Estado</th>
                                <th>Máquina</th>
                                <th>Inicio</th>
                                <th>Fin</th>
                                <th>Duración</th>
                                <th>Finalizado por</th>
                                <th>Progreso</th>
                                @if(canMainSubKey('productionOrderProcessDetail')){
                                    <th>Acciones</th>
                                }
                            </tr>
                        </thead>

            <tbody>
                @for ( process of innerTable.data; track process.id; let i = $index ) {
                <tr>
                    <td class="text-right align-middle">
                        <div class="flex items-center justify-end">
                            @if (process.id !== undefined && process.status?.name === ProductionOrderStates.PENDING) {
                            <div nz-button>
                                <svg class="w-5 h-5 text-yellow-500 mr-2" fill="none" stroke="currentColor"
                                    viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z">
                                    </path>
                                </svg>
                            </div>
                            }

                            <p>{{ i + 1 }}</p>
                        </div>
                    </td>

                    <td class="capitalize">
                        {{ process.description }}
                    </td>

                    <!--------------------------------------------------------------->
                    <!---------------------------- ESTADOS -------------------------->
                    <!--------------------------------------------------------------->
                    <td class="text-center align-middle">
                        <span [ngClass]="process.status?.cssClassName">
                            {{ process.status?.name ?? '' }}
                        </span>
                    </td>

                    <!--------------------------------------------------------------->
                    <!---------------------------- MAQUINAS -------------------------->
                    <!---------------------------------------------------------------->
                    @if (process.machine) {
                    <td class="capitalize">
                        {{ process.machine.name }}
                    </td>
                    }
                    @if (!process.machine) {
                    <td class="capitalize">
                        CUALQUIERA DE {{ process.description }}
                    </td>
                    }

                    <!--------------------------------------------------------------->
                    <!---------------------------- TIEMPOS --------------------------->
                    <!---------------------------------------------------------------->
                    <td class="capitalize">
                        @if (!process.productionTime) {
                        -
                        } @else {
                        {{
                        process.productionTime
                        .startDate
                        | date: ("dd/MM/YYYY HH:mm:ss")}}
                        }
                    </td>
                    <td class="capitalize">
                        @if (!process.productionTime) {
                        -
                        } @else {
                        {{
                        process.productionTime
                        .startDate
                        | date: ("dd/MM/YYYY HH:mm:ss")}}
                        }
                    </td>
                    <td class="capitalize">
                        @if (
                        !process.productionTime ||
                        !process.productionTime.endDate
                        ) {
                        -
                        } @else {
                        {{
                        getTotalDuration(
                        process.productionTime
                        .startDate,
                        process.productionTime
                        .endDate,
                        process.productionPauses!
                        )
                        }}
                        }
                    </td>
                    <td class="capitalize">
                        @if ( !process.productionTime || !process.productionTime.endDate ) { - }
                        @else {
                            {{ process.productionTime.finishedBy?.name }}
                        }
                    </td>

                    <td style="width: 140px !important;text-overflow: ellipsis;">
                        <nz-progress [nzPercent]="calculateProcessProgress(process)" nzSize="small"></nz-progress>
                    </td>

                    @if(canMainSubKey('productionOrderProcessDetail')){
                    <td>
                        <div class="flex align-middle justify-center">
                            <button nz-button nzType="text" nzShape="circle" class="table-icon"
                                [nzTooltipTitle]="'Ver proceso'" nzTooltipPlacement="bottom" nz-tooltip
                                (click)="navigateToProcessByIdOrderAndProcessId(data.id,process.id!)">
                                <span nz-icon nzType="fund-view"></span>
                            </button>

                            @if (!process.status!.isEndingStatus!) {
                                <nz-divider nzType="vertical"></nz-divider>

								<button nz-button nzType="text" nzShape="circle" class="table-icon"
										[nzTooltipTitle]="'Forzar finalizar del proceso ' + process.productionProcess!.name"
										nzTooltipPlacement="bottom" nz-tooltip (click)="forceFinishProduction(data.id, process)">
										<span nz-icon nzType="file-done"></span>
								</button>
							}
                        </div>
                    </td>
                    }
                </tr>
                }
            </tbody>
        </nz-table>
        </tr>
        }
        </tbody>
        </nz-table>
    </div>
</div>

<ng-template #indicatorTemplate>
    <app-loader></app-loader>
</ng-template>

<nz-drawer [nzClosable]="false" [nzVisible]="drawerVisible" nzPlacement="right" [nzTitle]="title" [nzFooter]="footer"
    [nzPlacement]="innerWidth > DRAWER_WIDTH_CHANGE_PLACEMENT ? 'right':'bottom'" [nzWidth]="'90%'"
    [nzHeight]="innerWidth > DRAWER_WIDTH_CHANGE_PLACEMENT ? '' : '90%'" (nzOnClose)="closeDrawer()"
    [nzMaskClosable]="fieldsReadOnly">
    <ng-template #title class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
        <div style="display: flex; align-items: center;">
            <p class="drawer-title"> {{ drawerTitle }} </p>
        </div>
    </ng-template>
    <ng-container *nzDrawerContent>
        <form nz-form [nzLayout]="'vertical'" (ngSubmit)="submitForm()">
            <!--TODO: VALIDATORS WITH FORM GROUP -> [formGroup]="validateForm"-->
            <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="p-4">
                <nz-form-item nz-col nzXs="24" nzSm="12" nzMd="12" class="px-4">
                    <nz-form-label nzRequired>
                        Descripción
                    </nz-form-label>
                    <nz-form-control nzErrorTip="Indique una descripción para la orden de producción">
                        <input onfocus="select()" nz-input
                            placeholder="Indique una descripción para la orden de producción"
                            [ngModel]="selectedEditOrder.description ? selectedEditOrder.description : ''" type="text"
                            [disabled]="fieldsReadOnly || orderStarted" id="description"
                            [ngModelOptions]="{standalone: true}" />
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item nz-col nzXs="24" nzSm="12" nzMd="12" class="px-4">
                    <nz-form-label nzRequired>
                        Cliente
                    </nz-form-label>
                    <nz-form-control nzErrorTip="Seleccione un cliente">
                        <nz-select nzShowSearch nzPlaceHolder="Selecciona un cliente" [(ngModel)]="customerSelected"
                            name="customerSelector" [nzDisabled]="fieldsReadOnly || orderStarted"
                            [compareWith]="compareById" [ngModelOptions]="{standalone: true}">
                            @for (c of customers; track c.id) {
                            <nz-option [nzLabel]="c.name" [nzValue]="c"></nz-option>
                            }
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item nz-col nzXs="24" nzSm="12" nzMd="8" class="px-4">
                    <nz-form-label nzRequired>
                        Prioridad
                    </nz-form-label>
                    <nz-form-control nzErrorTip="Seleccione una prioridad">
                        <nz-select nzShowSearch nzPlaceHolder="Seleccione una prioridad" [(ngModel)]="prioritySelected"
                            name="prioritySelector" [nzDisabled]="fieldsReadOnly" [compareWith]="compareById"
                            [ngModelOptions]="{standalone: true}">
                            @for (p of priorities; track p.id) {
                            <nz-option [nzLabel]="p.name" [nzValue]="p"></nz-option>
                            }
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item nz-col nzXs="24" nzSm="12" nzMd="8" class="px-4">
                    <nz-form-label>
                        Orden de prioridad
                    </nz-form-label>
                    <nz-form-control>
                        <input onfocus="select()" nz-input placeholder="Indique un número de orden de prioridad"
                            [value]="selectedEditOrder.priorityOrder ? selectedEditOrder.priorityOrder : ''"
                            type="number" [disabled]="fieldsReadOnly || orderStarted" id="priorityOrder" />
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item nz-col nzXs="24" nzSm="12" nzMd="8" class="px-4">
                    <nz-form-label>
                        Referencia
                    </nz-form-label>
                    <nz-form-control>
                        <input onfocus="select()" nz-input placeholder="Indique una referencia"
                            [value]="selectedEditOrder.reference ? selectedEditOrder.reference : ''" type="text"
                            [disabled]="fieldsReadOnly || orderStarted" id="reference" />
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item nz-col nzXs="24" nzSm="12" nzMd="8" class="px-4">
                    <nz-form-label>
                        Ruta
                    </nz-form-label>
                    <nz-form-control>
                        <nz-select nzShowSearch nzPlaceHolder="Seleccione una ruta" [(ngModel)]="routeSelected"
                            (ngModelChange)="onRouteChange($event)" name="routeSelector"
                            [nzDisabled]="fieldsReadOnly || orderStarted" [nzAllowClear]="true"
                            [compareWith]="compareById">
                            @for (r of routes; track r.id) {
                            <nz-option [nzLabel]="r.name" [nzValue]="r"></nz-option>
                            }
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item nz-col nzXs="24" nzSm="24" nzMd="16" class="px-4">
                    <nz-form-label>
                        Operarios
                    </nz-form-label>
                    <nz-form-control>
                        <nz-select [nzMaxTagCount]="5" [nzMaxTagPlaceholder]="tagPlaceHolder" nzMode="multiple"
                            nzPlaceHolder="Seleccione los operarios" [(ngModel)]="selectedUsers" name="operatorSelector"
                            [nzDisabled]="fieldsReadOnly || orderStarted" [compareWith]="compareUsers">
                            @for (user of users; track user.id) {
                            <nz-option [nzLabel]="user.name" [nzValue]="user"></nz-option>
                            }
                        </nz-select>
                        <ng-template #tagPlaceHolder let-selectedList>y {{ selectedList.length }} mas
                            seleccionados</ng-template>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item nz-col nzXs="24" nzSm="12" nzMd="6" class="px-4">
                    <nz-form-label nzRequired>
                        @if (showWithProductionOrdersPermissions('confirmationDateColumn')) {
                        Fecha de confirmación
                        } @else {
                        Fecha de inicio
                        }
                    </nz-form-label>
                    <nz-form-control nzErrorTip="Seleccione una fecha de inicio">
                        <nz-date-picker nzFormat="dd/MM/yyyy" id="startDate" name="startDate" [(ngModel)]="startDate" [ngModelOptions]="{standalone: true}" [nzDisabled]="fieldsReadOnly || orderStarted"></nz-date-picker>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item nz-col nzXs="24" nzSm="12" nzMd="6" class="px-4">
                    <nz-form-label nzRequired>
                        Fecha de entrega
                    </nz-form-label>
                    <nz-form-control nzErrorTip="Seleccione una fecha de entrega">
                        <nz-date-picker nzFormat="dd/MM/yyyy" id="deadlineDate" name="deadlineDate" [(ngModel)]="deadlineDate" [ngModelOptions]="{standalone: true}" [nzDisabled]="fieldsReadOnly"></nz-date-picker>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item nz-col nzXs="24" nzSm="12" nzMd="6" class="px-4">
                    <nz-form-label nzRequired>
                        Fecha de confirmación
                    </nz-form-label>
                    <nz-form-control nzErrorTip="Seleccione una fecha de confirmación">
                        <nz-date-picker nzFormat="dd/MM/yyyy" id="confirmationDate" name="confirmationDate" [(ngModel)]="confirmationDate" [ngModelOptions]="{standalone: true}" [nzDisabled]="fieldsReadOnly"></nz-date-picker>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item nz-col nzXs="24" nzSm="12" nzMd="6" class="px-4">
                    <nz-form-label nzRequired>
                        Fecha de envío
                    </nz-form-label>
                    <nz-form-control nzErrorTip="Seleccione una fecha de envío">
                        <nz-date-picker nzFormat="dd/MM/yyyy" id="deliveryDate" name="deliveryDate" [(ngModel)]="deliveryDate" [ngModelOptions]="{standalone: true}" [nzDisabled]="fieldsReadOnly"></nz-date-picker>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
                    <nz-form-label nzRequired>
                        Procesos de producción
                    </nz-form-label>
                    <nz-form-control nzErrorTip="Seleccione los procesos de producción">
                        <nz-select [nzMaxTagCount]="5" [nzMaxTagPlaceholder]="tagPlaceHolder" nzMode="multiple"
                            nzPlaceHolder="Seleccione los procesos de producción"
                            [ngModel]="selectedProductionProcesses"
                            (ngModelChange)="onProductionProcessessChange($event)" name="processSelector"
                            [nzDisabled]="fieldsReadOnly" [compareWith]="compareById">
                            @for (process of productionProcessess; track process.id) {
                            <nz-option [nzLabel]="process.name" [nzValue]="process"></nz-option>
                            }
                        </nz-select>
                        <ng-template #tagPlaceHolder let-selectedList>y {{ selectedList.length }} mas
                            seleccionados</ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <nz-table class="px-4 pb-4" nzTableLayout="auto" nzSize="small" [nzData]="productionProcessTableRows"
                [nzFrontPagination]="false" [nzShowPagination]="false" [nzBordered]="true">
                <thead>
                    <tr>
                        <th colspan="9">
                            @if (!fieldsReadOnly || !orderStarted) {
                            Orden de los procesos <span style="color:var(--app-terciary-color);">(Arrastra para
                                reordenar)</span>
                            }
                            @else {
                            Orden de los procesos
                            }
                        </th>
                    </tr>
                    <tr>
                        <th>Nº</th>
                        <th>Proceso</th>
                        <th>Descripción</th>
                        <th>Máquina</th>
                        <!--<th>Escandallo</th>-->
                        <th>Producto/s final/es</th>
                        <th>Materias primas a utilizar</th>
                        <th [hidden]="fieldsReadOnly">Acciones</th>
                    </tr>
                </thead>
                <tbody cdkDropList (cdkDropListDropped)="drop($event)">
                    @for (productionProcessRow of productionProcessTableRows; track idx; let idx = $index) {
                    <tr cdkDrag class="align-middle">
                        <td class="align-middle">
                            {{ idx + 1 + 'º' }}
                        </td>
                        <td class="align-middle">
                            {{ productionProcessRow.productionProcess.name }}
                        </td>
                        <td class="align-middle">
                            <input onfocus="select()" nz-input type="text" pattern="\d*" class="w-full"
                                [disabled]="fieldsReadOnly || orderStarted"
                                [(ngModel)]="productionProcessRow.description" [name]="'processDescription' + idx" />
                        </td>
                        <td class="align-middle">
                            <nz-select nzShowSearch nzPlaceHolder="Selecciona una máquina" class="w-full"
                                [(ngModel)]="productionProcessRow.machine" [name]="'machineSelector' + idx"
                                [nzDisabled]="fieldsReadOnly || isProcessLocked(productionProcessRow)" [compareWith]="compareById">
                                @for (r of machines; track subidx; let subidx = $index) {
                                <nz-option [nzLabel]="r.name" [nzValue]="r"></nz-option>
                                }
                            </nz-select>
                        </td>
                        <td>
                            <div class="flex items-center justify-center">
                                <div>
                                    <button nz-button type="button" nzType="text" nzShape="circle" (click)="onAddFinalProducts(productionProcessRow, idx)"
                                        [nzTooltipTitle]="'Ver y añadir productos finales'" nzTooltipPlacement="bottom"
                                        nz-tooltip class="table-icon">
                                        <span nz-icon nzType="appstore"></span>
                                    </button>
                                </div>
                                <div class="ml-2">
                                    ({{ productionProcessRow.finalProducts?.length || 0 }})
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="flex items-center justify-center">
                                <div>
                                    <button nz-button type="button" nzType="text" nzShape="circle" (click)="onShowAddRawMaterialsToUse(productionProcessRow)"
                                        [nzTooltipTitle]="'Ver y añadir materias primas'" nzTooltipPlacement="bottom"
                                        nz-tooltip class="table-icon" [disabled]="productionProcessRow.finalProducts?.length === 0">
                                        <span nz-icon nzType="appstore-add"></span>
                                    </button>
                                </div>
                                <div class="ml-2">
                                    ({{productionProcessRow.rawMaterialsToUse.length || 0}})
                                </div>
                            </div>
                        </td>
                        <td [hidden]="fieldsReadOnly">
                            <div class="flex items-center justify-center">
                                <div>
                                    <button nz-button nzType="text" type="button" nzShape="circle" class="table-icon"
                                        [nzTooltipTitle]="'Duplicar proceso'" nzTooltipPlacement="bottom" nz-tooltip
                                        (click)="cloneProductionOrderProcess(idx)">
                                        <span nz-icon nzType="copy"></span>
                                    </button>
                                    <nz-divider nzType="vertical"></nz-divider>
                                </div>

                                <div>
                                    <button nz-button nzType="text" nzShape="circle" class="table-icon"
                                        [nzTooltipTitle]="'Eliminar proceso'" nzTooltipPlacement="bottom" nz-tooltip
                                        (click)="removeProductionOrderProcess($event, idx)">
                                        <span nz-icon nzType="delete"></span>
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    }
                </tbody>
            </nz-table>
        </form>
    </ng-container>
    <ng-template #footer>
        <div class="flex justify-end">
            <button class="button secondary-button mr-2" (click)="cancelEditing()">
                Cancelar
            </button>

            @if (!fieldsReadOnly) {
            <button nz-button class="button primary-button" (click)="submitForm()" [nzLoading]="isSaving"> <!--TODO: [disabled]="!validateForm.valid" -->
                Guardar
            </button>
            }
        </div>
    </ng-template>
</nz-drawer>
